// extracted by mini-css-extract-plugin
export default {"page":"M0-z","cartModal":"N0-z","checkout":"O0-z","placeholder":"P0-z","account":"Q0-z"};